declare global {
  interface Window {
    gtag: Gtag.Gtag;
  }
}

const debug = (...args: Array<unknown>) => {
  if (import.meta.env.VITE_RUNTIME_ENV === 'development') {
    window.console.info('[GTAG]', ...args);
  }
};

export const init = (gaTagId: string, debugMode: boolean) => {
  const loadingScript = document.createElement('script');
  loadingScript.async = true;
  loadingScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaTagId}`;

  const setupScript = document.createElement('script');
  setupScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${gaTagId}', { 'debug_mode': ${debugMode} });
    `;

  document.head.prepend(loadingScript);
  loadingScript.after(setupScript);
  debug('Client initialized');
};

type Primitive = string | number | symbol | bigint | boolean | null | undefined;
type GoogleAnalyticsParams = Record<string, Primitive | Primitive[]>;

/**
 * @param {string} eventName - name of the event.
 * @param {GoogleAnalyticsParams} params - should always be an object, otherwise the event will not be sent.
 * Every params value is transformed into String, so should not send Object as params value since it will be [Object object].
 * */
export const sendEvent = (
  eventName: string,
  params?: GoogleAnalyticsParams,
) => {
  debug('sendEvent', eventName, params);
  window.gtag('event', eventName, params);
};
